import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InviteUsersDialogComponent } from './invite-users-dialog.component';
import { CopyToClipboardDirectiveModule } from '@go-modules/directives/go-clipboard/copy-to-clipboard.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		CopyToClipboardDirectiveModule
	],
	declarations: [
		InviteUsersDialogComponent
	],
	exports: [
		InviteUsersDialogComponent
	]
})
export class InviteUsersDialogModule {}
